import { render } from "./Youth.vue?vue&type=template&id=d442b15e"
import script from "./Youth.vue?vue&type=script&lang=js"
export * from "./Youth.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__